import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const cloudServiceField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Cloud service',
    context:
      'An identifier for the cloud service used. Examples: AWS Lambda, Google Storage.',
  }),
  externalDescription: msg({
    message:
      'An identifier for the cloud service used. Examples: AWS Lambda, Google Storage.',
    context: 'Cloud service',
  }),
};

export const cloudVmInstanceTypeField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Cloud virtual machine instance type',
    context: 'The virtual machine instance type for the cloud usage.',
  }),
  externalDescription: msg({
    message: 'The virtual machine instance type for the cloud usage.',
    context: 'Cloud virtual machine instance type',
  }),
};

export const cloudRegionField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Cloud region',
    context: `The identifier of the cloud provider's region. Examples: 'us-east-1' (AWS), 'asia-northeast2-a' (GCP).`,
  }),
  externalDescription: msg({
    message: `The identifier of the cloud provider's region. Examples: 'us-east-1' (AWS), 'asia-northeast2-a' (GCP).`,
    context: 'Cloud region',
  }),
};

export const cloudSpendField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Cloud spend',
    context: 'The spend on cloud services.',
  }),
  externalDescription: msg({
    message: 'The spend on cloud services.',
    context: 'Cloud spend',
  }),
};

export const cloudProviderField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Cloud provider',
    context: 'The cloud provider that the usage or spend is associated with.',
  }),
  externalDescription: msg({
    message: 'The cloud provider.',
    context: 'Cloud provider',
  }),
};
